webpackJsonp([11],{

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(784),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var DeviceCreationForm = function DeviceCreationForm() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 744));
};
var SnackBar = function SnackBar() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 743));
};
var CoordinatesInput = function CoordinatesInput() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 742));
};
var MarkerWindow = function MarkerWindow() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 745));
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'google-map',
  data: function data() {
    return {
      snackbar: true,
      dialog: false,
      icon: __webpack_require__(735),
      marker: null,
      coordinates: {
        lat: 0,
        lng: 0
      },
      infowindow: null,
      zoom: 11,
      map: null,
      mapName: this.name + '-map',
      loaded: false,
      orgId: this.$route.params.orgId
    };
  },

  computed: {
    google: __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__["gmapApi"],
    stringyfiedCoords: {
      get: function get() {
        var entries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.coordinates);
        return this.fixCoordinates(entries[0][1]) + ',' + this.fixCoordinates(entries[1][1]);
      },
      set: function set(value) {
        var coordinates = value.split(',');
        this.coordinates = {
          lat: this.fixCoordinates(parseFloat(coordinates[0])),
          lng: this.fixCoordinates(parseFloat(coordinates[1]))
        };
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    this.$refs.mapRef.$mapPromise.then(function (map) {
      that.map = map;
      that.coordinates.lat = map.getCenter().lat();
      that.coordinates.lng = map.getCenter().lng();
      map.setMapTypeId('satellite');
      map.addListener('center_changed', function () {
        that.coordinates.lat = map.getCenter().lat();
        that.coordinates.lng = map.getCenter().lng();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},

  methods: {
    fixCoordinates: function fixCoordinates(value) {
      return parseFloat(value.toFixed(6));
    },
    zoomControl: function zoomControl(variation) {
      this.zoom = parseInt(this.zoom) + variation;
      this.map.setZoom(this.zoom);
    },
    updateMap: function updateMap() {
      this.map.panTo(new this.google.maps.LatLng(this.coordinates));
    },
    accessLocation: function accessLocation() {
      var _this = this;

      this.$getLocation({}).then(function (coordinates) {
        _this.coordinates = coordinates;
        _this.map.panTo(coordinates);
      }).catch(function (error) {
        return console.log(error);
      });
    }
  },
  components: {
    'creationForm': DeviceCreationForm,
    'snackBar': SnackBar,
    'coordinatesForm': CoordinatesInput,
    'markerWindow': MarkerWindow
  }
});

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA0CAYAAADmI0o+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUUSURBVHgBzVlNbFRVFP46kLJpYVASaY3Ja0wsC6VjKLH4E6YsTF1AYUP8jSVsZFVYSMICLWGHC2AFmihtgomJRimaFFzYYWObdJCamliamL7GZGoM0NGa4DRBPN+97w2PYWbeefMHX3Iel3n3vPe9c84959zbJlSGuEjCky4Rx5NsQH4WSXkSGU2IhqRIv8gAutvi6Hwc6NwAPNkCtLcCyysiOfvvVAa4fhNIL5LkBZHTItPaF2mJOSLn0N6SRH8n8NazQOsanWZmmeSAM2kZ/zMsvxwTccPUNMQG0dp8Cge2CKHnUBUuzvkEh2AJVkSMcXROXLYbx5PWVbUALXjwe7qZ7t0HG49qYiQ1Li5L4PCLqAtOTACfzzDmeouRW1VCbQzvbenBwRdQN7z0FBfJRsz82SP/G4GC2IfodQZw9BXUHSSXzjgSc/TQ5eCtQlcmZOVdw6c7axdTYWBq2fsVFwRdmvJ/jhVM+wYHuhtHimhthllc9FQAQWJMmg52PYPIYFKdlWQ6tWjHUdHdLtKWlNFu/6fVgdvv4u3NiARm97NX/ezuer86pirskkTcH+EjmSf3fzcIWyXyMeZIbM1j7E3dQ2iVo1ckobhc7ofwYD3kl58U6zs4vE1fJV4eZsw5MlqI5R9Ec2rBBDnusvY9j+JFml/dIZl+xMzVglYG9vDiE9uOHR065dE5ui5FeorZA2bu+RmowKbANgp5YnSlStfElC0lWhzydMKxtY3XriCxhMe2PNIZ1roUFN1BANMSNymzYsNg05TjE4ubXKIB+yvbAEbFAq7f0M20XOIeMeWq+XsFFcI1GV4Dy2VdzCixFdHAmnodoqMLmzboZlou+XSRVWXsHQ6vzFFxRIPE8GPhs6xVTQvkE3Mxeytckf5nVmca0GPQJFpN/bVxOB0kdkUdnCy4a5tZcBOK2Y7MHTLlRoPA4vKJTUsmV+maL39/m+1wy1uOLr9m5mq7lR9cXlO8+LWSKWMJY29E2/3s/5Z9FE3PDtT17jjgFo/dAttyTX700fUJr+tFsn53kTVJcPZW0su+4aAVWPTTmYR8acK4Ya18VFuLXSRRai/BUmetZYI/2PaM4mxaiO1EJJheKiKJYhif5zXf+wcbxWHTV1XS6FULhsX4gguvF0MBMZpwBOd/QcNh35lCYBtX2POfkr0eGm41mxHu25kXEnPNImik1Rj0meVhFHQssSJTjzXUarZXe+AcoxixlFitMbFGUkWsRcRKqAzV3WpciTZ3FT31KXV2kcXKnSbk/kuabXw9wEOV9CI3NF8Uux0ro8oVmlW1xFFBa12cc807SmBVGfV/RXLykD5zilhL7P2avVex/aiKGDEpRTopBd7B5idQEzB2L/2Wgt0ol0Q5V/rYh4+vZtXtdznwGWd+ss8MQZjFiCxyd3LSPVTvUu7K3SxX4YWwqRpiRPUupQu//NWFdwQQBo0rfVTuUuqcmGCB7tWqaC1GWJemF/vQ9zSwZrVe067CIzK6pFWJQoyYxM3bCUm8m9SJl2Vn3B2W0RFEQFRixGU5aX5devk4OkK2lyw5H024KHOeXwpRYswHX7AHH6RQNt54z3YOjCsXEVGJxYg/pJb+VTLeWPzfGSU5JlF1XNWCGMF4W48bt3u8o4N7OD0F/Pg7C/QQKkQ1xIhJk3iBjdjq7ZTovs+mXRm9hocMR2Qex7ffxclX75qxd/j2KCAhZxRLsuFdwiNEyscAAn9AqBb/A9UItRhW6bFXAAAAAElFTkSuQmCC"

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "device-map",
    attrs: {
      "fluid": ""
    }
  }, [_c('snackBar'), _vm._v(" "), _c('creationForm', {
    attrs: {
      "orgId": _vm.orgId,
      "location": _vm.coordinates
    }
  }), _vm._v(" "), _c('coordinatesForm', {
    attrs: {
      "dialog": _vm.dialog,
      "coordinates": _vm.stringyfiedCoords
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      },
      "update:coordinates": function($event) {
        _vm.stringyfiedCoords = $event
      },
      "save": function($event) {
        return _vm.updateMap()
      }
    }
  }), _vm._v(" "), _c('markerWindow', {
    attrs: {
      "dialog": _vm.dialog,
      "lat": _vm.fixCoordinates(_vm.coordinates.lat),
      "lng": _vm.fixCoordinates(_vm.coordinates.lng)
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      }
    }
  }), _vm._v(" "), _c('v-img', {
    staticClass: "centered-marker",
    attrs: {
      "src": _vm.icon
    }
  }), _vm._v(" "), _c('GmapMap', {
    ref: "mapRef",
    staticClass: "gmap",
    attrs: {
      "options": {
        zoomControl: false,
        scrollwheel: true,
        gestureHandling: 'greedy',
        draggable: true,
        scaleControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        MotionTrackingControl: true,

      },
      "center": {
        lat: -38.001088,
        lng: -57.544016
      },
      "zoom": _vm.zoom
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "fab-container",
    attrs: {
      "column": ""
    }
  }, [_c('div', [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.accessLocation()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "color": "black"
    }
  }, [_vm._v("gps_fixed")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.zoomControl(1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "black"
    }
  }, [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.zoomControl(-1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "black"
    }
  }, [_vm._v("remove")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.b1f6e878161560184a66.js